/**
 * Public domain types.
 *
 * Everything in this file describes what a *client* is allowed to know.
 * The server's private state lives in `backend/src/game/state.ts` and is never
 * serialised directly — it is always projected through `projectGame()`, which is
 * the single place where secrecy rules are enforced.
 */
export const RATING_MIN = 0;
export const RATING_MAX = 5;
export function isRating(value) {
    if (typeof value !== 'number' || !Number.isInteger(value))
        return false;
    return value >= RATING_MIN && value <= RATING_MAX;
}
export function emptyAnswer() {
    return { heard: false, popular: false, moved: false };
}
//# sourceMappingURL=types.js.map